/* tslint:disable */
/* eslint-disable */
/**
 * EMLINX API specification
 * This is API specification for EMLINX project.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { ErrorResponse } from '../models';
// @ts-ignore
import { ListMasterItemsResponse } from '../models';
/**
 * ListmasteritemsApi - axios parameter creator
 * @export
 */
export const ListmasteritemsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List Master Items
         * @summary GET Master Items
         * @param {Array<string>} types Master Type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMasterItems: async (types: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'types' is not null or undefined
            assertParamExists('listMasterItems', 'types', types)
            const localVarPath = `/master-items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (types) {
                localVarQueryParameter['types'] = types;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ListmasteritemsApi - functional programming interface
 * @export
 */
export const ListmasteritemsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ListmasteritemsApiAxiosParamCreator(configuration)
    return {
        /**
         * List Master Items
         * @summary GET Master Items
         * @param {Array<string>} types Master Type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMasterItems(types: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMasterItemsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMasterItems(types, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ListmasteritemsApi.listMasterItems']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * ListmasteritemsApi - factory interface
 * @export
 */
export const ListmasteritemsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ListmasteritemsApiFp(configuration)
    return {
        /**
         * List Master Items
         * @summary GET Master Items
         * @param {Array<string>} types Master Type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMasterItems(types: Array<string>, options?: any): AxiosPromise<ListMasterItemsResponse> {
            return localVarFp.listMasterItems(types, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ListmasteritemsApi - object-oriented interface
 * @export
 * @class ListmasteritemsApi
 * @extends {BaseAPI}
 */
export class ListmasteritemsApi extends BaseAPI {
    /**
     * List Master Items
     * @summary GET Master Items
     * @param {Array<string>} types Master Type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListmasteritemsApi
     */
    public listMasterItems(types: Array<string>, options?: RawAxiosRequestConfig) {
        return ListmasteritemsApiFp(this.configuration).listMasterItems(types, options).then((request) => request(this.axios, this.basePath));
    }
}

